const n = {
  name: "LinkedinSmall",
  dimensions: { width: 24, height: 24 },
  content: `
  <svg fill="none">
    <path fill="currentColor" d="M18.1763 1.41174H5.82339C3.38809 1.41174 1.41162 3.38821 1.41162 5.82351V18.1765C1.41162 20.6117 3.38809 22.5882 5.82339 22.5882H18.1763C20.6116 22.5882 22.5881 20.6117 22.5881 18.1765V5.82351C22.5881 3.38821 20.6116 1.41174 18.1763 1.41174ZM8.47045 18.1765H5.82339V8.47057H8.47045V18.1765ZM7.14692 7.34998C6.29103 7.34998 5.6028 6.65292 5.6028 5.79704C5.6028 4.94115 6.29103 4.23527 7.14692 4.23527C8.0028 4.23527 8.69103 4.93233 8.69103 5.78821C8.69103 6.6441 8.0028 7.34998 7.14692 7.34998ZM19.0587 18.1765H16.4116V13.2353C16.4116 10.2617 12.8822 10.4912 12.8822 13.2353V18.1765H10.2352V8.47057H12.8822V10.0323C14.1175 7.74704 19.0587 7.57939 19.0587 12.2206V18.1765Z"/>
  </svg>
`
};
export {
  n as LinkedinSmall
};
